//跨域代理前缀
const API_PROXY_PREFIX = '/api/production/webpage';
const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_API_BASE_URL + '/production/webpage'
    : API_PROXY_PREFIX;

module.exports = {
  REAL_BASE_URL: 'http://47.93.25.52:9000/publicpic/',
  PRODUCT_CATEGORY_FIND: `${BASE_URL}/ProductCategoryFind  `,
  GET_CONTENT_SETTING: `${BASE_URL}/GetContentSetting  `,
  PRODUCTS_FIND: `${BASE_URL}/ProductsFind `,
  NEW_PRODUCT_FIND: `${BASE_URL}/newProductFind `,
  PRODUCTS_ECHO: `${BASE_URL}/ProductsEcho `,
  ADD_VOICE_MESSAGE: `${BASE_URL}/AddVoiceMessage `,
  NEWS_CONSULTATION_FIND: `${BASE_URL}/newsConsultationFind `,
  PRODUCT_DOCUMENT: `${BASE_URL}/ProductDocument `,
  NEWS_CONSULTATION_DETAILS: `${BASE_URL}/newsConsultationDetails `,
  PRODUCT_FILE_DOWNLOAD: `${BASE_URL}/ProductFileDownload `,
};
